{
    "CallsansweredwithinLabel": "As chamadas devem ser atendidas em:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "ServiceLvlSettings_SectionHeader": "Definições de nível de serviço",
    "ServiceLvlSettings_SectionPara": "Pode ajustar as seguintes definições para controlar especificamente como o relatório atual calcula a estatística \"% Nível de Serviço\", quando esta for suportada pelo estilo de relatório escolhido e estiver também selecionada para visualização.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Ignorar chamadas abandonadas rápidas em:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "A definição \"Ignorar chamadas rápidas abandonadas dentro\" está ativada?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Ignorar chamadas em sobrecarga em:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "A definição \"Ignorar chamadas em sobrecarga dentro\" está ativada?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s",
    "NAME": "ServiceLvlSettings"
}